import React from "react";
import { Modal } from 'semantic-ui-react'
import styled from 'styled-components'
import CustomButton from './Button'
import {words} from '../translations'

const SkipModal = ({open,setOpen, SkipQuestion,language}) =>{
  
    return (
      <Modal
      dimmer={'blurring'}
      open={open}
      onClose={() => setOpen(false)}>
        <Modal.Header>{words['ai_reminder_title'][language]}</Modal.Header>
          <ModalContent>
          {words['ai_reminder_body'][language]}
          </ModalContent>
          <Modal.Actions>
           
          
            <CustomButton type='skip' onClick={SkipQuestion}>
              {words['Skip anyway'][language]}
            </CustomButton>

            <CustomButton onClick={() =>setOpen(false)} type='leave'>
              {words['Leave feedback'][language]}
            </CustomButton>
          </Modal.Actions>
      </Modal>
  
    )
  }

export default SkipModal


const ModalContent = styled.div`
  padding:20px;
  font-size:16px;
  line-height:1.6;
  font-family:Poppins, sans-serif;

  @media (max-width:768px){
    font-size:14px;
  }
`